import {
  IconArchive,
  Menu,
  MenuButton,
  MenuItem,
  useMenuState,
} from '@vtex/admin-ui'
import { useNavigation } from '@vtex/raccoon-next'
import { useIntl } from 'react-intl'

export function ArchivedButtonLink() {
  const state = useMenuState()
  const { navigate } = useNavigation()
  const { formatMessage } = useIntl()

  return (
    <>
      <MenuButton
        state={state}
        labelHidden
        size="large"
        variant="neutralTertiary"
      />

      <Menu state={state}>
        <MenuItem
          icon={<IconArchive />}
          onClick={() => navigate('/archived')}
          label={formatMessage({ id: 'admin/promotions.archived.title' })}
        />
      </Menu>
    </>
  )
}
